<template>
  <div>
    <FormKit
      type="hidden"
      :name="`components[${index}][component_type]`"
      :value="component.component_type"
    />

    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <span class="font-weight-bold">Usps</span>
      </div>

      <div>
        <button type="button" class="btn btn-primary" @click="add">add</button>
      </div>
    </div>

    <div
      class="border-top py-4"
      v-for="(usp, uspIndex) in usps"
      :key="uspIndex"
    >
      <div class="mb-2 d-flex align-items-center justify-content-between">
        <div>
          <span class="font-weight-bold"> Usp #{{ uspIndex + 1 }} </span>
        </div>

        <div>
          <button
            type="button"
            class="btn btn-danger"
            @click="remove(uspIndex)"
          >
            <i class="lar la-trash-alt mr-2"></i>
          </button>
        </div>
      </div>

      <FormKit
        label="Titel"
        type="text"
        :name="`components[${index}][usps][${uspIndex}][title]`"
        v-model="usps[uspIndex].title"
      />
      <FormKit
        label="Omschrijving"
        type="textarea"
        :name="`components[${index}][usps][${uspIndex}][description]`"
        v-model="usps[uspIndex].description"
      />
      <FormKitImage
        label="Afbeelding"
        :name="`components[${index}][usps][${uspIndex}][image]`"
        v-model="usps[uspIndex].image"
      />
    </div>
  </div>
</template>

<script>
import mixin from "../mixins/component";

export default {
  name: "PageUsps",
  mixins: [mixin],
  data() {
    let usps = Object.values(this.modelValue?.usps ?? {});

    return {
      usps: [...usps],
    };
  },
  methods: {
    add() {
      this.usps.push({
        image: "",
        title: "",
        description: "",
      });
    },
    remove(index) {
      this.usps.splice(index, 1);
    },
  },
  watch: {
    usps: {
      deep: true,
      handler(usps) {
        this.update("usps", usps);
      },
    },
  },
};
</script>